export default __webpack_public_path__ + "static/media/1.3b0dc459.jpg";